import { c as _c } from "react/compiler-runtime";
import { range } from "es-toolkit/math";
import { SECTION_NAME_MAPPING } from "../ExpandedSearchResultSections/ExpandedSearchResultSections";
import { ExpandedSearchSection } from "../ExpandedSearchSection";
import { EXPANDED_SEARCH_ACCOUNTS_LIMIT, EXPANDED_SEARCH_COLLECTIONS_LIMIT, EXPANDED_SEARCH_CURRENCIES_LIMIT, EXPANDED_SEARCH_ITEMS_LIMIT } from "../hooks";
import { ExpandedSearchAccountResultSkeleton } from "../results/ExpandedSearchAccountResult";
import { ExpandedSearchCollectionResultSkeleton } from "../results/ExpandedSearchCollectionResult";
import { ExpandedSearchCurrencyResultSkeleton } from "../results/ExpandedSearchCurrencyResult";
import { ExpandedSearchItemResultSkeleton } from "../results/ExpandedSearchItemResult";
export function ExpandedSearchResultSectionSkeleton(t0) {
  const $ = _c(8);
  const {
    section
  } = t0;
  let T0;
  let t1;
  let t2;
  if ($[0] !== section) {
    let t3;
    bb0: {
      switch (section) {
        case "collection":
          {
            t3 = [ExpandedSearchCollectionResultSkeleton, EXPANDED_SEARCH_COLLECTIONS_LIMIT];
            break bb0;
          }
        case "currency":
          {
            t3 = [ExpandedSearchCurrencyResultSkeleton, EXPANDED_SEARCH_CURRENCIES_LIMIT];
            break bb0;
          }
        case "item":
          {
            t3 = [ExpandedSearchItemResultSkeleton, EXPANDED_SEARCH_ITEMS_LIMIT];
            break bb0;
          }
        case "account":
          {
            t3 = [ExpandedSearchAccountResultSkeleton, EXPANDED_SEARCH_ACCOUNTS_LIMIT];
            break bb0;
          }
      }
      t3 = undefined;
    }
    const [Comp, count] = t3;
    T0 = ExpandedSearchSection;
    t1 = SECTION_NAME_MAPPING[section];
    t2 = range(count).map(index => <Comp index={index} key={index} />);
    $[0] = section;
    $[1] = T0;
    $[2] = t1;
    $[3] = t2;
  } else {
    T0 = $[1];
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== T0 || $[5] !== t1 || $[6] !== t2) {
    t3 = <T0 heading={t1}>{t2}</T0>;
    $[4] = T0;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}